import React from 'react';
import cn from 'classnames';

import type { DsTextColor } from './typographyTextColor';
import { dsTextColorClassMap } from './typographyTextColor';

export interface TitleProps extends React.HTMLAttributes<HTMLElement> {
  size?: 'default' | 's';
  weight?: 'light' | 'medium';
  color?: DsTextColor;
  children: React.ReactNode;
  as?: React.ElementType;
}

export const Title: React.FC<TitleProps> = ({
  size = 'default',
  weight = 'light',
  color = 'primary',
  children,
  as: Component = 'div',
  className,
  ...props
}) => {
  const classes = cn(
    dsTextColorClassMap[color],
    {
      'text-ds-title': size === 'default',
      'text-ds-title-s': size === 's',
      'font-light': weight === 'light',
      'font-medium': weight === 'medium',
    },
    className,
  );

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

export default Title;
